export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";